import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWhiteSendIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.35531 13.3167C2.18658 13.3877 2 13.2638 2 13.0808V3.38552C2 3.20245 2.18659 3.07856 2.35531 3.1496L13.8684 7.99723C14.0773 8.08517 14.0773 8.38112 13.8684 8.46906L2.35531 13.3167ZM3.30829 11.5039L11.067 8.47155C11.284 8.38672 11.284 8.07956 11.067 7.99473L3.30829 4.96243V7.05207C3.30829 7.16953 3.38823 7.27191 3.50218 7.3004L6.23982 7.98481C6.49834 8.04944 6.49834 8.41684 6.23982 8.48147L3.50218 9.16588C3.38823 9.19437 3.30829 9.29675 3.30829 9.41421V11.5039Z",
		fill: "white"
	})
});
export default SvgWhiteSendIcon;
